import isArchived from 'archive/isArchived';
import {GraphQLTypes} from 'graphql-client/declarative-translations/external/GraphQLTypes';
import {graphQLArrayToREST} from 'graphql-client/declarative-translations/external/translate';

import {
  BoxSchema,
  ContainerSchema,
  LocationSchema,
  PlateSchema,
  PlateSchemaType,
} from './storables/StorableSchemaConstants';

function filterFn(
  schema:
    | GraphQLTypes['BoxSchema']
    | GraphQLTypes['ContainerSchema']
    | GraphQLTypes['LocationSchema']
    | GraphQLTypes['PlateSchema'],
  registryId: string | undefined
): boolean {
  if (isArchived(schema)) {
    return false;
  }
  if (!registryId) {
    return true;
  }
  return schema.registry.id === registryId;
}

export function getValidContainerSchemasFromQuery(
  data: {containerSchemas: Array<GraphQLTypes['ContainerSchema']>},
  registryId: string | undefined
): Array<ContainerSchema> {
  const gqlContainerSchemas = data.containerSchemas.filter((containerSchema) =>
    filterFn(containerSchema, registryId)
  );
  return graphQLArrayToREST('ContainerSchema', gqlContainerSchemas);
}

export function getValidBoxSchemasFromQuery(
  data: {boxSchemas: Array<GraphQLTypes['BoxSchema']>},
  registryId: string | undefined
): Array<BoxSchema> {
  const gqlBoxSchemas = data.boxSchemas.filter((boxSchema) => filterFn(boxSchema, registryId));
  return graphQLArrayToREST('BoxSchema', gqlBoxSchemas);
}

export function getValidLocationSchemasFromQuery(
  data: {locationSchemas: Array<GraphQLTypes['LocationSchema']>},
  registryId: string | undefined
): Array<LocationSchema> {
  const gqlLocationSchemas = data.locationSchemas.filter((locationSchema) =>
    filterFn(locationSchema, registryId)
  );
  return graphQLArrayToREST('LocationSchema', gqlLocationSchemas);
}

export function getValidPlateSchemasFromQuery(
  data: {plateSchemas: Array<GraphQLTypes['PlateSchema']>},
  registryId: string | undefined,
  plateSchemaType?: PlateSchemaType
): Array<PlateSchema> {
  const gqlPlateSchemas = data.plateSchemas.filter((plateSchema) => filterFn(plateSchema, registryId));
  let plateSchemas = graphQLArrayToREST('PlateSchema', gqlPlateSchemas);
  if (plateSchemaType) {
    plateSchemas = plateSchemas.filter((schema) => schema.plateSchemaType === plateSchemaType);
  }
  return plateSchemas;
}
